<div class="resumable-upload-container">
  @if (folderUploadSummaries.length > 0) {
    <div class="folder-upload-list">
      @for (folder of folderUploadSummaries; track folder) {
        <div class="folder-upload-item">
          <div class="file-info">
            <span class="folder-upload-name">
              <i class="pi pi-folder mr-2"></i>{{ folder.folderName }}
            </span>
            <span class="file-size">{{ formatBytes(folder.totalBytes) }}</span>
          </div>
          <div class="progress-section">
            <div class="progress-bar-container">
              <div
                class="progress-bar"
                [style.width.%]="folder.progress"
            [ngClass]="{
              'progress-queued': folder.status === 'queued' && folder.progress === 0,
              'progress-initializing': folder.status === 'initializing',
              'progress-uploading': folder.status === 'uploading',
              'progress-paused': folder.status === 'paused',
              'progress-completed': folder.status === 'completed',
              'progress-failed': folder.status === 'failed'
            }">
              </div>
            </div>
            <span class="progress-text">{{ folder.progress.toFixed(1) }}%</span>
          </div>
          <div class="status-actions-wrapper">
            <div class="status-section">
              <span class="status-badge" [ngClass]="'status-' + folder.status">
                {{ getStatusText(folder.status) }}
              </span>
              @if (!folder.isComplete) {
                <div class="folder-upload-status">
                  {{ folder.status === 'uploading' ? 'Uploading' : (folder.status === 'paused' ? 'Paused' : 'Pending') }}... {{ folder.uploadedItems }} / {{ folder.totalItems }} items
                </div>
              }
              @if (folder.isComplete) {
                <div class="folder-upload-status complete">
                  Upload Complete <i class="pi pi-check"></i>
                </div>
              }
            </div>
            <div class="actions-section">
              @if (folder.status === 'uploading' || folder.status === 'initializing' || folder.status === 'queued') {
                <button
                  (click)="onPauseFolderUpload(folder.folderName)"
                  class="action-btn icon-btn pause-btn"
                  [class.is-loading]="isControlActionLoading('folder:pause:' + folder.folderName)"
                  [disabled]="isControlActionLoading('folder:pause:' + folder.folderName)"
                  [title]="'Pause Folder'">
                  @if (!isControlActionLoading('folder:pause:' + folder.folderName)) {
                    <i class="pi pi-pause"></i>
                  }
                  @if (isControlActionLoading('folder:pause:' + folder.folderName)) {
                    <i class="pi pi-spinner pi-spin"></i>
                  }
                </button>
              }
              @if (folder.status === 'paused') {
                <button
                  (click)="onResumeFolderUpload(folder.folderName)"
                  class="action-btn icon-btn resume-btn"
                  [class.is-loading]="isControlActionLoading('folder:resume:' + folder.folderName)"
                  [disabled]="isControlActionLoading('folder:resume:' + folder.folderName)"
                  [title]="'Resume Folder'">
                  @if (!isControlActionLoading('folder:resume:' + folder.folderName)) {
                    <i class="pi pi-play"></i>
                  }
                  @if (isControlActionLoading('folder:resume:' + folder.folderName)) {
                    <i class="pi pi-spinner pi-spin"></i>
                  }
                </button>
              }
              <button
                (click)="confirmRemoveFolderUpload(folder.folderName)"
                class="action-btn icon-btn cancel-btn"
                [title]="'Remove Folder Upload'">
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (displayedUploads.length > 0) {
    <div class="upload-list">
      @for (upload of displayedUploads; track upload) {
        <div class="upload-item" [ngClass]="'status-' + upload.status">
          <!-- File Info -->
          <div class="file-info">
            <span class="file-name" [title]="upload.file.name">{{ upload.file.name }}</span>
            <span class="file-size">{{ formatBytes(upload.totalBytes) }}</span>
          </div>
          <!-- Progress Section -->
          <div class="progress-section">
            <div class="progress-bar-container">
              <div
                class="progress-bar"
                [style.width.%]="upload.progress"
            [ngClass]="{
              'progress-queued': upload.status === 'queued' && upload.progress === 0,
              'progress-initializing': upload.status === 'initializing',
              'progress-uploading': upload.status === 'uploading' || (upload.status === 'queued' && upload.progress > 0 && upload.sessionId),
              'progress-paused': upload.status === 'paused' || (upload.status === 'queued' && upload.progress > 0 && !upload.sessionId),
              'progress-completed': upload.status === 'completed',
              'progress-failed': upload.status === 'failed'
            }">
              </div>
            </div>
            <span class="progress-text">{{ upload.progress.toFixed(1) }}%</span>
          </div>
          <!-- Status and Actions -->
          <div class="status-actions-wrapper">
            <div class="status-section">
              <span class="status-badge" [ngClass]="'status-' + (upload.status === 'queued' && upload.progress > 0 && upload.sessionId ? 'uploading' : (upload.status === 'queued' && upload.progress > 0 ? 'paused' : upload.status))">
                {{ getStatusText(upload.status === 'queued' && upload.progress > 0 && upload.sessionId ? 'uploading' : (upload.status === 'queued' && upload.progress > 0 ? 'paused' : upload.status)) }}
              </span>
            </div>
            <div class="actions-section">
              <!-- Pause Icon -->
              @if (upload.status === 'uploading') {
                <button
                  (click)="onPauseUpload(upload.fileId)"
                  class="action-btn icon-btn pause-btn"
                  [class.is-loading]="isControlActionLoading('file:pause:' + upload.fileId)"
                  [disabled]="isControlActionLoading('file:pause:' + upload.fileId)"
                  [title]="'Pause'">
                  @if (!isControlActionLoading('file:pause:' + upload.fileId)) {
                    <i class="pi pi-pause"></i>
                  }
                  @if (isControlActionLoading('file:pause:' + upload.fileId)) {
                    <i class="pi pi-spinner pi-spin"></i>
                  }
                </button>
              }
              <!-- Resume Icon - only for real files (not placeholders) -->
              @if (upload.status === 'paused' && upload.file && !isPlaceholderFile(upload.file)) {
                <button
                  (click)="onResumeUpload(upload.fileId)"
                  class="action-btn icon-btn resume-btn"
                  [class.is-loading]="isControlActionLoading('file:resume:' + upload.fileId)"
                  [disabled]="isControlActionLoading('file:resume:' + upload.fileId)"
                  [title]="'Resume'">
                  @if (!isControlActionLoading('file:resume:' + upload.fileId)) {
                    <i class="pi pi-play"></i>
                  }
                  @if (isControlActionLoading('file:resume:' + upload.fileId)) {
                    <i class="pi pi-spinner pi-spin"></i>
                  }
                </button>
              }
              <!-- Retry Icon -->
              @if (upload.status === 'failed') {
                <button
                  (click)="retryUpload(upload.fileId)"
                  class="action-btn icon-btn retry-btn"
                  [title]="'Retry'">
                  <i class="pi pi-refresh"></i>
                </button>
              }
              <!-- Cancel Icon -->
              @if (upload.status === 'uploading' || upload.status === 'paused' || upload.status === 'queued' || upload.status === 'initializing') {
                <button
                  (click)="confirmCancelUpload(upload.fileId)"
                  class="action-btn icon-btn cancel-btn"
                  [title]="'Cancel'">
                  <i class="pi pi-times"></i>
                </button>
              }
              <!-- Remove Icon (for completed/failed/cancelled) -->
              @if (upload.status === 'completed' || upload.status === 'failed' || upload.status === 'cancelled') {
                <button
                  (click)="confirmRemoveFile(upload.fileId)"
                  class="action-btn icon-btn remove-btn"
                  [title]="'Remove'">
                  <i class="pi pi-trash"></i>
                </button>
              }
            </div>
          </div>
          <!-- Error Message -->
          @if (upload.error && upload.status === 'failed') {
            <div class="error-message">
              <i class="pi pi-exclamation-triangle"></i>
              {{ upload.error }}
            </div>
          }
          <!-- Paused Message -->
          @if (upload.status === 'paused' && !upload.error) {
            <div class="paused-message">
              <i class="pi pi-pause"></i>
              Upload paused.
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Empty State -->
  @if (displayedUploads.length === 0 && folderUploadSummaries.length === 0) {
    <div class="empty-state">
      <p>No files in upload queue</p>
    </div>
  }
</div>
